module.exports = __webpack_public_path__ + "static/media/bowser_0.fd8ca527.png";